import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import Logs from './Logs';
import { useLogsContext } from './LogsContext';

const LogsContainer = (props) => {
  const { collection, initializingError, isInitializing } = useLogsContext();

  return (
    <DataContainer
      component={Logs}
      componentProps={{
        collection,
      }}
      loading={isInitializing}
      loadingError={initializingError}
      {...props}
    />
  );
};

export default LogsContainer;
